// Copyright (c) 2019 Deere & Company

import actions from '../../action-list';
import {getDefaultState as getClaimDefaultState} from '../state';

const setClaimValidity = (state, action) => action.validity;
const resetClaimValidity = () => getClaimDefaultState().isValidClaim;

export default (state = getClaimDefaultState().isValidClaim, action) => {

    const actionTypes = {
        [actions.COPY_CLAIM_WEAR_PARTS]: resetClaimValidity,
        [actions.UPDATE_CLAIM_WEAR_PARTS_IS_VALID_CLAIM]: setClaimValidity,
        [actions.ADD_CLAIM_WEAR_PARTS_ADDITIONAL_REPAIR]: resetClaimValidity,
        [actions.RESET_CLAIM_WEAR_PARTS]: resetClaimValidity
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/wear-parts/reducers/is-valid-claim.js